import { render, staticRenderFns } from "./ContestDetails.vue?vue&type=template&id=3f2141d8&scoped=true"
import script from "./ContestDetails.vue?vue&type=script&lang=js"
export * from "./ContestDetails.vue?vue&type=script&lang=js"
import style0 from "./ContestDetails.vue?vue&type=style&index=0&id=3f2141d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2141d8",
  null
  
)

export default component.exports